<template>
  <div class="container">
    <div class="container__title">忘记密码</div>
    <div class="container__sub-title">为保证账户安全，重置密码需要验证手机号</div>
    <Form ref="form" :rules="rules" :form="form" class="forget">
      <FormItem ref="phone" prop="phone">
        <div class="form__item__prefix">
          <img class="form__item__prefix__img" src="../../assets/img/icon-phone.svg" />
        </div>
        <Input v-model="form.phone"></Input>
      </FormItem>
      <FormItem class="forget__wrap" prop="password" :validateCallback="validateCallback">
        <InputPassword v-model="form.password" placeholder="请输入新密码（数字、字母或@.-_）"></InputPassword>
        <div class="forget__wrap__tips">
          <div
            v-for="item in tips"
            class="forget__wrap__tips__item">
            <img
              v-if="errorTip === item.key"
              class="forget__wrap__tips__item__icon"
              src="../../assets/img/icon-error.png" />
            <img
              v-else
              class="forget__wrap__tips__item__icon"
              src="../../assets/img/icon-tick.svg" />
            <span
              :class="'forget__wrap__tips__item__content' + (errorTip === item.key ? ' forget__wrap__tips__item__content_error' : '')"
              >{{item.label}}</span>
          </div>
        </div>
      </FormItem>
      <FormItem prop="secondPassword">
        <InputPassword v-model="form.secondPassword" placeholder="请再次输入新密码"></InputPassword>
      </FormItem>
      <FormItem ref="captcha" prop="captcha">
        <InputCaptcha v-model="form.captcha" :checkPhoneFn="checkPhone" v-on:error="showError" v-on:success="showSuccess"></InputCaptcha>
      </FormItem>
      <div class="form__btns">
        <button type="button" class="button button_primary" @click="submitHandler" :disabled="loading">确认</button>
        <button type="button" class="button button_default" @click="cancelHandler" :disabled="loading">取消</button>
      </div>
    </Form>
  </div>
</template>
<script>
import Form from '@/components/Form'
import FormItem from '@/components/FormItem'
import Input from '@/components/Input'
import InputCaptcha from '@/components/InputCaptcha'
import InputPassword from '@/components/InputPassword'
// import { encrypt } from '@/utils/rsa'
// import PUBLICKEY from '@/constant/publicKey'
import { tsmEncrypt } from '@/utils/tsm'
import '@/assets/less/forget.less'

export default {
  components: {
    Form,
    FormItem,
    Input,
    InputCaptcha,
    InputPassword
  },
  data() {
    return {
      form: {
        phone: '',
        captcha: '',
        password: '',
        secondPassword: ''
      },
      rules: {
        phone: [
          { type: 'require', message: '请输入手机号' }
        ],
        captcha: [
          { type: 'require', message: '请输入验证码' }
        ],
        password: [
          { type: 'regex', pattern: /^[A-Za-z\d@._-]{6,15}$/, tipType: 'length' },
          { type: 'regex', pattern: /\d+/, tipType: 'number' },
          { type: 'regex', pattern: /[a-zA-Z]+/, tipType: 'char' }
        ],
        secondPassword: [
          { type: 'require', message: '请再次输入密码' },
          {
            type: 'function',
            validate: (value) => {
              return value === this.form.password
            },
            message: '两次输入的密码不一致'
          }
        ]
      },
      tips: [
        {
          key: 'length',
          label: '6-15位合法字符'
        },
        {
          key: 'number',
          label: '包含数字'
        },
        {
          key: 'char',
          label: '包含字母'
        }
      ],
      errorTip: null,
      loading: false
    }
  },
  methods: {
    async submitHandler() {
      const flag = this.$refs.form.validate()
      if (!flag) {
        return false
      }
      this.loading = true
      // 用公钥加密密码。
      // const encryptedPassword = encrypt(PUBLICKEY, this.form.password)
      // tsm加密
      const tsmEncryptedPassword = await tsmEncrypt(this.form.password)
      // 请求设置密码
      const { status, data } = await this.$post(this.$CGI.login.setPassword, {
        phone: this.form.phone,
        // encrypted: encryptedPassword,
        tsmEncrypted: tsmEncryptedPassword,
        captcha: this.form.captcha
      }, false)
      this.loading = false
      if (status === 200) {
        this.$router.push('/forget/success')
      } else {
        this.showError(data)
      }
    },
    cancelHandler() {
      this.$router.push('/login/account')
    },
    checkPhone(res) {
      const flag = this.$refs.phone.validate(this.form.phone)
      if (flag) {
        return this.form.phone
      } else {
        return false
      }
    },
    validateCallback(error) {
      if (error) {
        this.errorTip = error.tipType
      } else {
        this.errorTip = null
      }
    },
    showSuccess(data) {
      this.$Message.success(data)
      // this.dispatch('App', 'showSuccess', data)
    },
    showError(data) {
      if (data.type && this.$refs[data.type]) {
        this.$refs[data.type].setError({ message: data.msg })
      } else {
        this.$Message.error(data.msg || data)
        // this.dispatch('App', 'showError', data.msg || data)
      }
    }
  }
}
</script>
